<template>
  <NewModalWrapper modalName="roles" maxWidth="max-w-[716px]">
    <div class="text-blue mt-6 flex flex-col gap-2 text-2xl font-normal">
      <span class="mb-6"> {{ $t("homepage.switch_roles") }} </span>
      <RadioImage
        v-for="role in currentUser.available_roles"
        :key="role"
        :value="role"
        :label="role"
        :modelValue="currentUser.role"
        :img="getImage(role)"
        @update:modelValue="onChangeContext"
      >
      </RadioImage>
    </div>
  </NewModalWrapper>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import NewModalWrapper from "@/components/Core/NewModalWrapper.vue";
import RadioImage from "@/components/Core/RadioImage.vue";

export default {
  name: "DoctorReferralHistory",
  components: {
    NewModalWrapper,
    RadioImage,
  },
  computed: {
    ...mapGetters({
      currentUser: "user/getCurrentUser",
    }),
  },
  methods: {
    ...mapMutations({
      closeModal: "modals/closeModal",
    }),
    getImage(value) {
      switch (value) {
        case "doctor":
          return require("@/assets/images/base/icons/stethoscope.svg");
        case "patient":
          return require("@/assets/images/base/icons/user.svg");
        default:
          return require("@/assets/images/base/icons/buildings.svg");
      }
    },
    onChangeContext(role) {
      this.closeModal("roles");
      if (["admin", "doctor"].includes(role)) {
        window.location.href = `${process.env.VUE_APP_DOCTOR_URL}?role=${role}`;
      }
    },
  },
};
</script>
